var componentCls = '.ant-spin';
var spinStyleFn = function spinStyleFn(token) {
  var _sm, _ref, _antSpinNestedLoa;
  return {
    '.ant-spin-nested-loading': (_antSpinNestedLoa = {}, _antSpinNestedLoa["> div > " + componentCls] = (_ref = {}, _ref[componentCls + "-text"] = {
      // https://cooper.didichuxing.com/docs/document/2200512335156
      // loading图标和下方文字间距统一为8px
      paddingTop: 8
    }, _ref['&-sm'] = (_sm = {}, _sm[componentCls + "-text"] = {
      // loading图标和下方文字间距统一为8px
      paddingTop: 12
    }, _sm), _ref), _antSpinNestedLoa),
    '.ant-spin .ant-spin-dot': {
      boxShadow: "inset 3px 0 0 0 " + token.colorFillSecondary + ",\n      inset -3px 0 0 0 " + token.colorFillSecondary + ",\n      inset 0 3px 0 0 " + token.colorFillSecondary + ",\n      inset 0 -3px 0 0 " + token.colorFillSecondary,
      borderRadius: '50%'
    },
    '.ant-spin-lg .ant-spin-dot': {
      boxShadow: "inset 4px 0 0 0 " + token.colorFillSecondary + ",\n      inset -4px 0 0 0 " + token.colorFillSecondary + ",\n      inset 0 4px 0 0 " + token.colorFillSecondary + ",\n      inset 0 -4px 0 0 " + token.colorFillSecondary,
      borderRadius: '50%'
    }
  };
};

export { spinStyleFn };
